/** Shown where a settled, empty plan list would otherwise leave a blank page. */
export const NO_MATCHING_PLANS_MESSAGE =
  'We could not find any matching Products for you. Please email contact@joinheard.com for further assistance.'
